import React from "react";
import { Box, Flex, Text, Icon } from "@chakra-ui/react";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi2";
import { c } from "../classroomColors";

const Step = ({ item, direction, onGo }) => {
  const isNext = direction === "next";
  if (!item) return <Box flex="1" />;
  return (
    <Flex
      as="button"
      onClick={() => onGo(item.node)}
      flex="1"
      minW={0}
      direction="column"
      align={isNext ? "flex-end" : "flex-start"}
      gap="3px"
      px="16px"
      py="13px"
      borderRadius="12px"
      border="1px solid"
      borderColor={c.borderSoft}
      bg={c.surface}
      textAlign={isNext ? "right" : "left"}
      transition="border-color 0.15s, background 0.15s"
      _hover={{ bg: c.hover, borderColor: c.textMuted }}
    >
      <Flex align="center" gap="6px" direction={isNext ? "row" : "row-reverse"}>
        <Text fontSize="11px" fontWeight="500" color={c.textMuted} letterSpacing="0.03em">
          {isNext ? "NEXT" : "PREVIOUS"}
        </Text>
        <Icon as={isNext ? HiArrowRight : HiArrowLeft} boxSize="12px" color={c.textMuted} />
      </Flex>
      <Text fontSize="13.5px" fontWeight="500" color={c.text} noOfLines={1} width="100%">
        {item.node.name}
      </Text>
    </Flex>
  );
};

/** Coursera's move-through-the-course footer: the next lesson is the most
 *  likely next click, so it should not require going back to the outline. */
const LessonNav = ({ prev, next, onGo }) => {
  if (!prev && !next) return null;
  return (
    <Flex gap="10px" mt="34px" pt="22px" borderTop="1px solid" borderColor={c.borderSoft}>
      <Step item={prev} direction="prev" onGo={onGo} />
      <Step item={next} direction="next" onGo={onGo} />
    </Flex>
  );
};

export default LessonNav;
